import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { H5, P } from '../../../../AbstractElements';

const LoadingScreenCard = ({ screen, onEdit, onDelete, onToggleStatus }) => {
  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody className="p-3">
        {/* Image Preview */}
        {screen.url && (
          <div className="mb-3">
            <img 
              src={screen.mediumUrl || screen.url} 
              alt={screen.filename}
              className="img-fluid rounded"
              style={{width: '100%', height: '200px', objectFit: 'cover'}}
            />
          </div>
        )}

        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Badge color={screen.isActive ? 'success' : 'secondary'}>
                {screen.isActive ? 'Active' : 'Inactive'}
              </Badge>
              <Badge color="info">
                <i className="fa fa-clock me-1"></i>
                {(screen.time / 1000).toFixed(1)}s
              </Badge>
            </div>
            <H5 className="text-dark mb-1">{screen.filename}</H5>
            <small className="text-muted">
              {screen.size && `Size: ${(screen.size / 1024).toFixed(2)} KB`}
            </small>
          </div>
          <div className="d-flex gap-2">
            <Button 
              color="outline-primary" 
              size="sm"
              onClick={() => onEdit(screen)}
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button 
              color="outline-danger" 
              size="sm"
              onClick={() => onDelete(screen.id)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </div>

        {/* File Details */}
        <div className="mb-3 p-3 bg-light rounded">
          <div className="row g-2">
            <div className="col-12">
              <small className="text-muted d-block">Mimetype</small>
              <strong className="small">{screen.mimetype || 'N/A'}</strong>
            </div>
            {screen.filePath && (
              <div className="col-12">
                <small className="text-muted d-block">File Path</small>
                <small className="text-dark text-break">{screen.filePath}</small>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            {screen.createdAt && `Created: ${new Date(screen.createdAt).toLocaleDateString('vi-VN')}`}
          </small>
          <Button
            color={screen.isActive ? 'warning' : 'success'}
            size="sm"
            onClick={() => onToggleStatus(screen.id)}
          >
            <i className={`fa fa-${screen.isActive ? 'eye-slash' : 'eye'} me-1`}></i>
            {screen.isActive ? 'Tắt' : 'Bật'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default LoadingScreenCard;

